// Copyright © 2015-2020 TrampleZone LLC All Rights Reserved

// AdSensePlatform Module

// This module provides support for advertising in the Client application.
// There are several different types of desktop ads supported: banners,
// verticalbanners, smallsquares, squares, leaderboards, skyscrapers,
// and interstitials.  NOTE: There are 2 verticalbanners as they are small.
//
// Support for throttling display rate is also provided.  For example,
// one can decide to only show an ad in the slot a certain percentage of the
// time.  This is important to be responsive to user input and maximize
// ad revenue and user satisfaction.
//
// Sample AdSense code from Google
// <script async src="//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>
// <!-- Small Square -->
// <ins class="adsbygoogle"
//     style="display:inline-block;width:200px;height:200px"
//     data-ad-client="ca-pub-6997258709540607"
//     data-ad-slot="1225938776"></ins>
// <script>
// (adsbygoogle = window.adsbygoogle || []).push({});
// </script>


define('AdSensePlatform',['require','GoogleAdSense','Policies','Utilities'],function (require) {
    'use strict';

    var // Require.js module dependencies
        GoogleAdSense = require('GoogleAdSense'),
        Policies = require('Policies'),
        Utilities = require('Utilities'),

        // Common
        policies,
        utilities,
        platformName = 'AdSense',       // Name of the ad platform in use
        initialized,                    // True if ad platform was initialized
        bannerRate = 1.0,               // How frequently to show banner ads
        interstitialRate = 0.3,         // How frequently to show interstitials
        publisherId,                    // Publisher ID for advertising
        adSlots,                        // Advertising credentials

        // Other
        main,
        ins;


    // Constructor
    function AdSensePlatform () {

        // Dependent resources
        policies = new Policies();
        utilities = new Utilities();

        // Public Methods

        // Set Google Publisher ID
        this.setPublisherId = function () {
            publisherId = policies.getPolicy('googlePublisherId');
        };

        // Set Ad Slots
        this.setAdSlots = function () {
            // Credentials
            adSlots = {
                banner: {
                    adClient:           publisherId,
                    adSlot:             policies.getPolicy(
                                            'adSenseBannerAdSlot') || '',
                    displayRate:        bannerRate,
                    width:              '320px',
                    height:             '50px',
                    adReady:            false,
                    isAdShowing:        false
                },
                verticalbanner1: {
                    adClient:           publisherId,
                    adSlot:             policies.getPolicy(
                                            'adSenseVerticalbanner1AdSlot') || '',
                    displayRate:        bannerRate,
                    width:              '120px',
                    height:             '240px',
                    adReady:            false,
                    isAdShowing:        false
                },
                verticalbanner2: {
                    adClient:           publisherId,
                    adSlot:             policies.getPolicy(
                                            'adSenseVerticalbanner2AdSlot') || '',
                    displayRate:        bannerRate,
                    width:              '120px',
                    height:             '240px',
                    adReady:            false,
                    isAdShowing:        false
                },
                leaderboard: {
                    adClient:           publisherId,
                    adSlot:             policies.getPolicy(
                                            'adSenseLeaderboardAdSlot') || '',
                    displayRate:        bannerRate,
                    width:              '728px',
                    height:             '90px',
                    adReady:            false,
                    isAdShowing:        false
                },
                smallsquare: {
                    adClient:           publisherId,
                    adSlot:             policies.getPolicy(
                                            'adSenseSmallsquareAdSlot') || '',
                    displayRate:        bannerRate,
                    width:              '200px',
                    height:             '200px',
                    adReady:            false,
                    isAdShowing:        false
                },
                square: {
                    adClient:           publisherId,
                    adSlot:             policies.getPolicy(
                                            'adSenseSquareAdSlot') || '',
                    displayRate:        bannerRate,
                    width:              '250px',
                    height:             '250px',
                    adReady:            false,
                    isAdShowing:        false
                },
                skyscraper: {
                    adClient:           publisherId,
                    adSlot:             policies.getPolicy(
                                            'adSenseSkyscraperAdSlot') || '',
                    displayRate:        bannerRate,
                    width:              '160px',
                    height:             '600px',
                    adReady:            false,
                    isAdShowing:        false
                }
            };
        };

        // Set the display rate for banner ads
        this.setAdSlotDisplayRate = function (newBannerRate) {
            // Desktop rates
            adSlots.banner.displayRate          = bannerRate;
            adSlots.verticalbanner1.displayRate = bannerRate;
            adSlots.verticalbanner2.displayRate = bannerRate;
            adSlots.square.displayRate          = bannerRate;
            adSlots.smallsquare.displayRate     = bannerRate;
            adSlots.leaderboard.displayRate     = bannerRate;
            adSlots.skyscraper.displayRate      = bannerRate;
        };

        // Set the display rate for interstitial ads
        this.setInterstitialDisplayRate = function (newInterstitialRate) {
            // Unsupported for now
        };

        // Set ad display Rates based on policies
        this.setDisplayRates = function () {
            // Ad Slots
            var newBannerRate = policies.getPolicy('adDisplayRateBanner');
            if (newBannerRate) {
                this.setAdSlotDisplayRate(parseFloat(newBannerRate));
            }
            // Interstitials
            var newInterstitialRate =
                    policies.getPolicy('adDisplayRateInterstitial');
            if (newInterstitialRate) {
                this.setInterstitialDisplayRate(parseFloat(newInterstitialRate));
            }
        };
    };

    // Public Prototype Methods

    // Initializations
    AdSensePlatform.prototype.initialize = function (newMain) {
        // Save reference to Main.js
        main = newMain;

        // Set advertising credentials from Server policies
        this.setPublisherId();
        this.setAdSlots();

        // Set display rates from Server policies
        this.setDisplayRates();

        // Set initial state
        initialized = true;
    };

    // Show ad in specified element
    AdSensePlatform.prototype.showAd = function (
        visible, type, parentDiv, callback) {
        // Remove any previous ad
        while (parentDiv.firstChild) {
            parentDiv.removeChild(parentDiv.firstChild);
        }

        // Construct and show new ad if requested
        if (visible && !adSlots[type].isAdShowing) {
            // Create a new ad element
            ins = document.createElement('ins');
            ins.setAttribute('class', 'adsbygoogle');
            ins.style.width = adSlots[type].width;
            ins.style.height = adSlots[type].height;
            ins.style.display = 'inline-block';

            // Assign ad client and slot ids
            ins.setAttribute('data-ad-client',
                             adSlots[type].adClient);
            ins.setAttribute('data-ad-slot',
                             adSlots[type].adSlot);

            // Parent should be full size, just in case
            parentDiv.style.width = ins.style.width;
            parentDiv.style.height = ins.style.height;

            // Add ad to parent element
            parentDiv.appendChild(ins);
            (adsbygoogle = window.adsbygoogle || []).push({});
        }

        // Show or hide
        parentDiv.style.display = (visible ? 'inline-block' : 'none');

        // Record that ad is currently [not] showing
        adSlots[type].isAdShowing = visible;

        // Notify listeners if any
        if (callback) {
            callback();
        }
    };

    // Show small banner ad
    AdSensePlatform.prototype.showBannerAd = function (
        visible, parentDiv, callback) {
        this.showAd(visible, 'banner', parentDiv, callback);
    };

    // Show verticalbanner1 ad
    AdSensePlatform.prototype.showVerticalbanner1Ad = function (
        visible, parentDiv, callback) {
        this.showAd(visible, 'verticalbanner1', parentDiv, callback);
    };

    // Show verticalbanner2 ad
    AdSensePlatform.prototype.showVerticalbanner2Ad = function (
        visible, parentDiv, callback) {
        this.showAd(visible, 'verticalbanner2', parentDiv, callback);
    };

    // Show leaderboard ad
    AdSensePlatform.prototype.showLeaderboardAd = function (
        visible, parentDiv, callback) {
        this.showAd(visible, 'leaderboard', parentDiv, callback);
    };

    // Show small square ad
    AdSensePlatform.prototype.showSmallSquareAd = function (
        visible, parentDiv, callback) {
        this.showAd(visible, 'smallsquare', parentDiv, callback);
    };

    // Show square ad
    AdSensePlatform.prototype.showSquareAd = function (
        visible, parentDiv, callback) {
        this.showAd(visible, 'square', parentDiv, callback);
    };

    // Show skyscraper ad
    AdSensePlatform.prototype.showSkyscraperAd = function (
        visible, parentDiv, callback) {
        this.showAd(visible, 'skyscraper', parentDiv, callback);
    };

    // Get Ad platform name
    AdSensePlatform.prototype.getAdPlatform = function () {
        return platformName;
    };

    // Return Constructor
    return AdSensePlatform.prototype.constructor;
});

